import { IEirSalesViewAvailableAppointments } from "@modules/eirSalesFacade/interfaces/models/IEirSalesViewAvailableAppointments";
import { IEirSalesViewAvailableAppointmentsResponse } from "@modules/eirSalesFacade/interfaces/responses/IEirSalesViewAvailableAppointmentsResponse";

export const mapEirSalesViewAvailableAppointmentsResponse = (
    response: IEirSalesViewAvailableAppointmentsResponse
): IEirSalesViewAvailableAppointments => ({
    reference: response.reference,
    status: response.status,
    availableSlots: response.availableSlots,
});
